import React from 'react';
import { Link } from 'react-router-dom';

export default function Footer() {
  const currentYear = new Date().getFullYear();

  const links = [
    { label: 'Forside', href: '/' },
    { label: 'Køletransport', href: '/koeletransport' },
    { label: 'Om os', href: '/om-os' },
    { label: 'Kontakt', href: '/kontakt' },
    { label: 'Ydelse', href: '/ydelse' },
    { label: 'Referencer', href: '/referencer' }
  ];

  return (
    <footer className="bg-brand-dark-card border-t border-brand-dark-border mt-auto">
      <div className="mx-auto max-w-[1400px] px-4 py-16 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-12">
          
          {/* Column 1: Brand & CVR */}
          <div className="space-y-4">
            <div className="flex items-center gap-3">
              <img 
                src="https://assets.auxodev.dk/assets/c3c69980-e6b4-4d46-bdae-26d6f6795887/logo.svg" 
                alt="Chr. Nielsen & Søn" 
                className="h-10 w-auto object-contain brightness-0 invert"
              />
            </div>
            <p className="text-sm text-gray-400 max-w-xs leading-relaxed">
              Professionel og pålidelig køletransport i Jylland samt resten af Danmark. Medlem af DTL.
            </p>
            <div className="text-xs text-gray-500">
              CVR nr.: <span className="text-gray-400 font-mono">19047938</span>
            </div>
          </div>

          {/* Column 2: Quick Links */}
          <div>
            <h3 className="text-sm font-bold uppercase tracking-[0.15em] text-white border-l-2 border-brand-red pl-3 mb-6">
              Hurtige Links
            </h3>
            <ul className="grid grid-cols-2 gap-x-4 gap-y-3">
              {links.map((link) => (
                <li key={link.href}>
                  <Link 
                    to={link.href} 
                    className="text-sm text-gray-400 hover:text-brand-red transition-colors duration-200 flex items-center gap-2"
                  >
                    <i className="fa-solid fa-chevron-right text-[10px] text-brand-red/50" />
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Column 3: Contact Info */}
          <div>
            <h3 className="text-sm font-bold uppercase tracking-[0.15em] text-white border-l-2 border-brand-green pl-3 mb-6">
              Kontaktoplysninger
            </h3>
            <ul className="space-y-4">
              <li className="flex items-start gap-3">
                <i className="fa-solid fa-location-dot text-brand-red mt-1 text-base w-5 flex-shrink-0 text-center" />
                <span className="text-sm text-gray-400 leading-relaxed">
                  <strong>CHR. NIELSEN & SØN V/LEIF NIELSEN</strong><br />
                  Jordrupvej 4<br />
                  6600 Vejen
                </span>
              </li>
              <li>
                <a 
                  href="tel:40535984" 
                  className="flex items-center gap-3 text-sm text-gray-400 hover:text-brand-red transition-colors duration-200 group"
                >
                  <i className="fa-solid fa-phone text-brand-red text-base w-5 flex-shrink-0 text-center group-hover:scale-110 transition-transform" />
                  <span className="font-semibold text-white group-hover:text-brand-red transition-colors">40 53 59 84</span>
                </a>
              </li>
              <li>
                <a 
                  href="mailto:info@chrnielsen.dk" 
                  className="flex items-center gap-3 text-sm text-gray-400 hover:text-brand-green transition-colors duration-200 group"
                >
                  <i className="fa-solid fa-envelope text-brand-green text-base w-5 flex-shrink-0 text-center group-hover:scale-110 transition-transform" />
                  <span className="font-semibold text-brand-green group-hover:text-brand-green-hover transition-colors">info@chrnielsen.dk</span>
                </a>
              </li>
            </ul>
          </div>

        </div>

        {/* Bottom Bar */}
        <div className="border-t border-brand-dark-border mt-12 pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-gray-500 text-center sm:text-left">
            &copy; {currentYear} CHR. NIELSEN & SØN V/LEIF NIELSEN. Alle rettigheder forbeholdes.
          </p>
          <div className="flex items-center gap-6 text-xs text-gray-500">
            <span className="flex items-center gap-1.5">
              <span className="h-2.5 w-2.5 rounded-full bg-brand-green inline-block" />
              Kølekæde Sikret
            </span>
            <span className="flex items-center gap-1.5">
              <i className="fa-solid fa-shield-halved text-brand-red" />
              DTL Medlem
            </span>
          </div>
        </div>
      </div>
    </footer>
  );
}
